import { render } from "./ProductSummaryTile.vue?vue&type=template&id=27255006&scoped=true"
import script from "./ProductSummaryTile.vue?vue&type=script&lang=ts"
export * from "./ProductSummaryTile.vue?vue&type=script&lang=ts"

import "./ProductSummaryTile.vue?vue&type=style&index=0&id=27255006&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-27255006"

export default script